
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

// Register components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  // const dualHorizontalBarsChartData = {
  //   labels: ["Math", "Science", "English", "History", "Art"],
  //   datasets: [
  //     {
  //       label: "Boys",
  //       backgroundColor: "#4F46E5", // Indigo
  //       data: [65, 59, 80, 81, 56],
  //       borderWidth: 0,
  //     },
  //     {
  //       label: "Girls",
  //       backgroundColor: "#F43F5E", // Rose
  //       data: [45, 79, 60, 91, 66],
  //       borderWidth: 0,
  //     },
  //   ],
  // };

const ClusteredBarChart = ({
  label,
  label1,
  label2,
  color,
  color1,
  data,
  data2,
  stepSize,
  isLabel,
}) => {
  const dualHorizontalBarsChartData = {
    labels: label,
    datasets: [
      {
        label: label1,
        backgroundColor: color,
        data: data,
        borderWidth: 0,
        barThickness: 10, 
      },
      {
        label: label2,
        backgroundColor: color1,
        data: data2,
        borderWidth: 0,
        barThickness: 10,
      },
    ],
  };

  const dualChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y",
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          min: 0, // v3 still supports min
          stepSize: stepSize,
          display: false,
        },
      },
      y: {
        display: isLabel,
        ticks: {
          font: {
            size: 14,
          },
        }
      },
    },
  };

  return <Bar data={dualHorizontalBarsChartData} options={dualChartOptions} />;
};

export default ClusteredBarChart;



// import React, { Component } from 'react';
// // import { HorizontalBar } from 'react-chartjs-2';



// export default class ClusteredBarChart extends Component {
  

//       render() {
//         const dualHorizontalBarsChartData = { 
//             labels: this.props.label,
//             datasets: [ 
//                 { 
//                     label: this.props.label1,
//                     backgroundColor: this.props.color,
//                     data:this.props.data,
//                     borderWidth: 0,
//                 },{
//                     label: this.props.label2,
//                     backgroundColor: this.props.color1,
//                     data:this.props.data2,
//                     borderWidth: 0,
//                 }
//             ]
//         }
//         const  dualChartOptions = { 
//                 responsive: true ,
//                 maintainAspectRatio:false,
//                 barPercentage: 1,
//                 legend: {
//                   display: false
//                 },
//                 scales: {
//                   xAxes: [
//                     {
//                       ticks:{
//                           min: 0,
//                           stepSize:this.props.stepSize
//                       }
//                     }
//                   ],
//                   yAxes: [
//                     {
//                         display: this.props.isLabel
//                     }
//                   ]
//                 }
//               }
//         return null;
//         // return <HorizontalBar data={dualHorizontalBarsChartData} options={dualChartOptions} />
//       }
// }